import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------product page api's-------------------------------->
    getProducts(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/invoiceindex/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getProductsExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/invoiceexport/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    /**
     * 
     * @param {*} data 
     */
    postImportProduct(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/invoiceimport', data)
    },
    /**
     * get detials list for product
     */
    getProductDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/details')
    },
    getProductFilterDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/filterdetails')
    },
    postProduct(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/create', form)
    },
    postProductTag(tag_name, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/PdtTagCreate', tag_name)
    },
    getProduct(id,type, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/view/'  + id + '?type=' + type)
    },
    postProductUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/update/' + id, form)
    },
    postPdtdelete(ids, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/delete', ids)
    },
    postPdtstatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/statuschange', data)
    },
    /**
     * 
     * @param {*} data 
     */
    pricelistedit(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/pricelistedit', data)
    },
    postsinglestatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/singlestatuschange', data)
    },
    postFiltercreateProduct(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/filtercreate/' + '?application=invoice', data)
    },
    postFilterudpateProduct(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/filterupdate/' + id + '?application=invoice', data)
    },
    postFilterdeleteProduct(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/filterdelete', data)
    },
    /**
     * products transaction view page api
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    postProductcreditview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/pdtcreditview/' + page + '/' + count, id)
    },
    postProductinvoiceview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/pdtinvoiceview/' + page + '/' + count, id)
    },
    postProductquotationview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/pdtquotationview/' + page + '/' + count, id)
    },
    postsalesorderview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/pdtsalesview/' + page + '/' + count, id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getViewTotalCount(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/totalcount', data)
    },
    /**
     * get product view list
     * @param {*} id 
     */
    getProductView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/viewpage/' + id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getProductDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/singledelete', data)
    },
    importproductvalidation(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/importvalidation', data)
    },
    importProduct(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/import', data)
    },
    /**
     * 
     * @param {*} data 
     */
    postcreatesku(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/getSku', data)
    },
    /**
     * 
     * @param {*} data 
     */
    getproductswithoutsku(page, show, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/productswithoutsku/' + page + '/' + show)
    },
    /**
     * 
     * @param {*} data 
     */
    getproductsskuexport(page, show, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/products/exportwithoutsku/' + page + '/' + show)
    },
    customizePdtUnits(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/products/unitconfigure', data)
    },

}